export const filterBy = (type, id, everything, setter) => {
  // console.log("filtering by: ", type, ", id: ", id);
  switch (type) {
    case "person":
      const newList = everything.filter(
        (x) =>
          x.original.people &&
          x.original.people.length &&
          x.original.people.filter((y) => y._id === id).length
      );
      setter(newList);
      break;
    case "mediaType":
      const mediaList = everything.filter(
        (x) =>
          x.original.mediaType &&
          x.original.mediaType._id &&
          x.original.mediaType._id === id
      );
      setter(mediaList);
      break;
    case "keyword":
      const keywordList = everything.filter(
        (x) =>
          x.original.keywords &&
          x.original.keywords.length &&
          x.original.keywords.filter((y) => y._id === id).length
      );
      setter(keywordList);
      break;
    case "objectType":
      const objectList = everything.filter((x) => x.type === id);
      setter(objectList);
      break;
    case "clear":
    default:
      setter(everything);
  }
};
